import { env } from '../config';

// Add type definitions for MenuItem and Page
export interface MenuItem {
  title: string;
  path: string;
  external?: boolean;
}



export const parseMenuConfig = (): MenuItem[] => {
  const menuConfig = env.VITE_MENU_CONFIG;
  if (!menuConfig.trim()) {
    console.warn('No menu configuration found');
    return [];
  }
  
  return menuConfig.split(',')
    .filter((item: string) => item.trim()) // Remove empty items
    .map((item: string): MenuItem | null => {
      const parts = item.trim().split('|');
      if (parts.length !== 2) {
        console.warn(`Invalid menu item format: ${item}`);
        return null;
      }
      
      const [label, path] = parts;
      return {
        title: label.trim(),
        path: path.trim(),
        external: path.startsWith('http')
      };
    })
    .filter((item: MenuItem | null): item is MenuItem => item !== null); // Remove invalid items
};
